module.exports = "https://www.ilove11.top/img/face93.69479f8d.gif";